import {
  setLineHeight,
  setMargin,
  getPropertyValue,
} from './applyComputedStyles'
import {
  styleNames,
  serializeDataInline,
  serializeLinkDataInline,
} from './dataInline'

// Outlook's Word rendering engine doesn't support the rgba() function (with or
// without an alpha channel) and drops the whole color declaration, so use rgb().
// https://linear.app/getanewsletter/issue/FE-1271
const hex2rgb = (hex) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16))
  return `rgb(${r},${g},${b})`
}

const isHex = (hex) => hex && hex[0] === '#'

const getUpdatedStyles = (values, tag) => {
  const updatedStyles = {}

  switch (true) {
    case tag === 'h1':
    case tag === 'h2':
    case tag === 'h3':
    case tag === 'h4': {
      if (values[`headings_${tag}FontSize`]) {
        updatedStyles['font-size'] = `${values[`headings_${tag}FontSize`]}px`
      }
      if (values.headings_color) {
        updatedStyles.color = isHex(values.headings_color)
          ? hex2rgb(values.headings_color)
          : values.headings_color
      }
      if (values.headings_fontWeight) {
        updatedStyles['font-weight'] = values.headings_fontWeight
      }
      if (values.headings_fontFamily) {
        updatedStyles['font-family'] = values.headings_fontFamily
      }
      break
    }
    case tag === 'a':
    case tag === 'ul':
    case tag === 'ol':
    case tag === 'p': {
      const colorKey = tag !== 'a' ? 'normalText_color' : 'link_color'
      if (values[colorKey]) {
        updatedStyles.color = isHex(values[colorKey])
          ? hex2rgb(values[colorKey])
          : values[colorKey]
      }
      if (values.normalText_fontFamily) {
        updatedStyles['font-family'] = values.normalText_fontFamily
      }
      if (values.normalText_fontSize) {
        updatedStyles['font-size'] = `${values.normalText_fontSize}px`
      }
    }
  }
  updatedStyles.margin = '0 0 10px'
  return updatedStyles
}

export const updateDataInline = (values, htmlText) => {
  const container = document.createElement('div')
  container.style.display = 'none'
  container.classList.add('section-inner')

  window.document.body.appendChild(container)

  container.innerHTML = htmlText

  Array.from(container.querySelectorAll('[data-inline]')).forEach((item) => {
    if (item.tagName.toLowerCase() === 'a') {
      return
    }
    const dataInline = item.getAttribute('data-inline')

    const itemStyles = window.getComputedStyle(item, null)
    const styles = styleNames
      .filter(
        (key) =>
          typeof getPropertyValue(itemStyles, key) !== 'undefined' &&
          getPropertyValue(itemStyles, key) !== ''
      )
      .map((key) => ({ [key]: getPropertyValue(itemStyles, key) }))
      .reduce((result, current) => ({ ...result, ...current }), {})

    const dataInlineStyles = dataInline
      .split(';')
      .map((rule) => {
        const [name, value] = rule.split(':')
        return { [name]: value }
      })
      .reduce((result, current) => ({ ...result, ...current }), {})
    const dataInlineStylesPrepared = Object.keys(dataInlineStyles)
      .filter((key) => styleNames.indexOf(key) > -1)
      .filter(
        (key) =>
          typeof dataInlineStyles[key] !== 'undefined' &&
          dataInlineStyles[key] !== ''
      )
      .map((key) => ({ [key]: dataInlineStyles[key] }))
      .reduce((result, current) => ({ ...result, ...current }), {})
    const updatedStyles = getUpdatedStyles(values, item.tagName.toLowerCase())

    const combinedStyles = {
      ...dataInlineStylesPrepared,
      ...styles,
      ...updatedStyles,
    }

    const stylesString = serializeDataInline(combinedStyles)

    item.setAttribute(
      'data-inline',
      `${stylesString}${setLineHeight(item, values)}${setMargin(item, values)}`
    )

    const aTags = item.getElementsByTagName('a')

    Array.prototype.forEach.call(aTags, (link) => {
      const styles = window.getComputedStyle(link, null)
      const color = isHex(styles.color) ? hex2rgb(styles.color) : styles.color
      link.setAttribute('data-inline', serializeLinkDataInline(color))
    })
  })

  window.document.body.removeChild(container)

  return container.innerHTML
}
